import { createApp } from 'vue'
import Questions from '@/javascripts/components/Questions'
import TurbolinksAdapter from 'vue-turbolinks'

document.addEventListener('turbolinks:load', () => {
  if (document.querySelector('[data-vue="questions"]')) {
    const app = createApp({
      mixins: [TurbolinksAdapter],
      components: { Questions }
    })

    app.mount('[data-vue="questions"]')
  }
})
